import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import tealiumWrapper from './tealiumWrapper';
import { extractSecondaryValues } from '../propExtractor';
import {
  TEALIUM_SCHEMA_CLICK_EXTERNAL_LINK,
  TEALIUM_SCHEMA_EMAIL_LEAD_TO_AGENT,
  TEALIUM_SCHEMA_SAVE_PROPERTY,
  TEALIUM_SCHEMA_VIEW_EMAIL_AGENT_FORM,
  TEALIUM_SEARCH_REFINEMENT_MODAL_OPEN,
} from './constants';

const trackEmailLeadToAgentEvent = ({
  agencies,
  listingId,
  responses,
  selectedContact,
  product,
  tenureTypeObject,
}) => {
  const { message, phone, email, desiredInformation, emailOthers } = responses;
  const agentInfo = {
    agency_id: emailOthers ? agencies[0].id : selectedContact.agencyId,
    secondary_agency_ids: emailOthers ? extractSecondaryValues(agencies, 'id') : undefined,
    agent_id: !emailOthers ? selectedContact?.id : undefined,
  };

  tealiumWrapper.trackEvent(() => ({
    schema: TEALIUM_SCHEMA_EMAIL_LEAD_TO_AGENT,
    data: {
      event_name: 'email_lead_to_agent',
      listing_id: listingId,
      enquiry_type: desiredInformation,
      email_provided: !isEmpty(email),
      message_provided: !isEmpty(message),
      mobile_provided: !isEmpty(phone),
      product_depth: product,
      tenure_type: tenureTypeObject?.omniture,
      ...agentInfo,
    },
  }));
};

const trackAppPromotionLinkClick = () =>
  tealiumWrapper.trackEvent(() => ({
    schema: TEALIUM_SCHEMA_CLICK_EXTERNAL_LINK,
    data: {
      event_name: 'click_external_link',
      product: 'Download App',
      type: 'rca mobile',
    },
  }));

const trackEmailOpenClick = ({ agencies, listingId, inPageSource, product, tenureTypeObject }) =>
  tealiumWrapper.trackEvent(() => ({
    schema: TEALIUM_SCHEMA_VIEW_EMAIL_AGENT_FORM,
    data: {
      event_name: 'view_email_agent_form',
      agency_id: get(agencies, '[0].id'),
      secondary_agency_ids: extractSecondaryValues(agencies, 'id'),
      listing_id: listingId,
      in_page_source: inPageSource,
      product_depth: product,
      tenure_type: tenureTypeObject?.omniture,
    },
  }));

const trackSavePropertyEvent = ({ listingId, userAction, agencies = [], product, tenure }) =>
  tealiumWrapper.trackEvent(() => ({
    schema: TEALIUM_SCHEMA_SAVE_PROPERTY,
    data: {
      event_name: 'save_property',
      agency_id: get(agencies, '[0].id'),
      secondary_agency_ids: extractSecondaryValues(agencies, 'id'),
      listing_id: listingId,
      user_action: userAction,
      product_depth: product,
      tenure_type: tenure?.omniture,
    },
  }));

const trackSearchRefinementModalOpen = ({ searchMode, userAction }) => {
  tealiumWrapper.trackEvent(() => ({
    schema: TEALIUM_SEARCH_REFINEMENT_MODAL_OPEN,
    data: {
      event_name: 'search_refinement_modal_open',
      user_action: `${searchMode}:${userAction}`,
    },
  }));
};

export {
  trackEmailLeadToAgentEvent,
  trackAppPromotionLinkClick,
  trackEmailOpenClick,
  trackSavePropertyEvent,
  trackSearchRefinementModalOpen,
};
